import { createFileRoute } from '@tanstack/react-router';
import CollectionUsagePage from '@/pages/workspaces/journeys/collections/[collectionId]/usage.page';
import { LazyPage } from './-route-layouts';

function CollectionUsageRoute() {
  return (
    <LazyPage>
      <CollectionUsagePage />
    </LazyPage>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage',
)({
  component: CollectionUsageRoute,
});
